
export const ru = {
    privatisation: 'Настройки частного доступа',
    configs_manager: 'Управление конфигурацией доступа',
    private_devices_manager: 'Привязка устройств',

    second: 'секунда',
    seconds: 'секунд',
    minute: 'минута',
    minutes: 'минут',
    hour: 'час',
    hours: 'часов',
    config_name: 'Название',
    net_type: 'Тип подключения',
    ali_iot: 'Aliyun IoT',
    custom_mqtt: 'Собственный MQTT',
    encrypt_type: 'Метод шифрования',
    secret_key: 'Секретный ключ',
    no_encrypt: 'Без шифрования',
    fixed_encrypt: 'Фиксированный ключ',
    report_interval: 'Интервал загрузки',
    collect_interval: 'Интервал записи',
    ble_interval: 'Интервал вещания BLE',
    ble_name: 'Имя вещания BLE',
    device_count: 'Количество устройств',
    operations: 'Управление',
    please_select: 'Выберите',
    re_select: 'Выбрать заново',
    edit_ali_iot_info_tip: 'Информация о сервере Aliyun IoT',
    custom_config: 'Пользовательская конфигурация',
    edit_mqtt_info_tip: 'Информация о собственном MQTT',
    add_config: 'Добавить конфигурацию',
    add: 'Добавить',
    host_area: 'Область',

    config: 'Название',
    config_message: 'Введите название конфигурации',
    device_type: 'Модель устройства',
    config_status: 'Статус отправки конфигурации',
    config_sent_time: 'Время отправки',
    active_time: 'Время активации',
    create_time: 'Время добавления',
    current_platform: 'Платформа',

    add_device: 'Добавить устройство',

    //menu
    menu_edit: 'Редактировать',
    menu_delete: 'Удалить',
    change_config: 'Изменить',

    //edit config
    config_has_devices: '\'%1\' содержит %2 устройств. Необходимо сначала отвязать устройства, чтобы удалить конфигурацию.',
    confirm_to_delete_config: 'Вы уверены, что хотите удалить конфигурацию "%$"?',

    //add device
    select_device_type: 'Выберите модель устройства',
    select_devices: 'Выберите устройство',
    select_devices2: 'Перед настройкой, пожалуйста, добавьте устройство в свою учетную запись в приложении "Qingping IoT".',
    select_config: 'Выберите конфигурацию',
    selected_devices_count: 'Всего выбрано @$ устройств',
    prev: 'Назад',
    next: 'Далее',

    table_footer: '@$ устройств выбрано',
    confirm_to_delete_device_title: 'Вы уверены, что хотите удалить устройство "%$"?',
    confirm_to_delete_device_content: 'После удаления только связь между устройством и конфигурацией будет удалена, локальная конфигурация устройства останется неизменной. Для очистки локальной конфигурации выполните сброс устройства до заводских настроек.',

    delete_success: 'Успешно удалено.',
    delete_failed: 'Ошибка удаления.',

    edit_success_title: 'Успешно отредактировано.',
    edit_success_fail: 'Ошибка редактирования.',
    device__edit_success: 'Конфигурация %0 устройств была изменена на "%1". Пожалуйста, выполните сброс устройств до заводских настроек. Новая конфигурация будет отправлена при подключении устройства к серверу Qingping. Для Wi-Fi устройств настройте сеть в приложении Qingping после сброса.',

    add_success_title: 'Успешно добавлено.',
    add_success_fail: 'Ошибка добавления.',
    add_success_sub_title: 'Частная конфигурация будет отправлена при подключении устройства к серверу Qingping. Если устройство подключается по интервалу, нажмите кнопку на корпусе, чтобы принудительно подключиться.',

    access_key_access_secret_tips: 'Информацию об AccessKey и AccessSecret смотрите в ',
    access_key_access_secret_tips2: '3.2.3 RAM. ',

    product_key_tip: 'Информацию о ProductKey смотрите в ',
    product_key_tip2: '3.2.2. ',

    mqtt_tips: 'Информацию о собственном MQTT смотрите в ',
    mqtt_tips2: '3.2. ',

    use_thing_model: 'TSL',

    table_total: 'Всего %$ элементов',
    qingping: '© Qingping',

    no_permission: 'Нет доступа.',
    please_contact: 'Пожалуйста, свяжитесь:',
    contact_email: 'Эл. почта: ',
    contact_tel: 'Телефон: %@',

    // new tabs
    unsent_devices: 'Не отправлено',
    sent_devices: 'Отправлено',
    config_send_status: 'Статус отправки',
    send_config: 'Отправить конфигурацию',
    send_config_success: 'Успешно отправлено',
    send_config_failed: 'Ошибка отправки',
    send_config_success_sub_title: 'Приватная конфигурация была отправлена на @$ устройств и вступит в силу при подключении к Интернету.',
    sent: 'Отправлено',
    unsent: 'Не отправлено',
    consent: 'Подтвердить',
    cancel: 'Отмена',
    send_private_mqtt_config: 'Отправить приватную MQTT конфигурацию',
    select_private_config: 'Выберите приватную конфигурацию',

    // Edit MQTT Config Success Tips
    mqtt_config_modified_title: 'Приватная MQTT конфигурация "%$" была изменена',
    attention_label: 'Внимание:',
    mqtt_config_modified_warning: 'Эта конфигурация только обновляет облачные записи. Чтобы она вступила в силу на устройстве, выполните следующие действия:',
    wifi_device_step_label: '1. Устройство Wi-Fi:',
    wifi_device_step_text: 'Восстановите заводские настройки, затем используйте приложение Qingping IoT (Ещё > Расширенные > Настроить Wi-Fi) для перенастройки сети и получения новой конфигурации.',
    nb_iot_device_step_label: '2. Устройство NB-IoT / Cat-1:',
    nb_iot_device_step_text: 'Просто восстановите заводские настройки; устройство автоматически получит новую конфигурацию.',
    i_known: 'Понятно',
};